import TimeReport from "../time-report"

const debug = false
// const debug = "timeReport_autoCorrectDurationAndStartEnd"

const DAY_IN_MINUTES = 24 * 60

export default function timeReport_autoCorrectDurationAndStartEnd(timeReport: TimeReport, updatedField: "startMoment" | "endMoment" | "reportedTimeMinutes") {
    switch (updatedField) {
        case "startMoment":
            if (!timeReport.startMoment) {                                                              // if startMoment is set to null then endMoment should be set to null too
                timeReport._endMoment = null
                timeReport.updatedFields.add('endMoment')
            } else {                                                                                    // startMoment is set
                if (timeReport.reportedTimeMinutes) {                                                   // if reportedTimeMinutes is set then update endDate
                    //TODO если все есть и мы меняем startMoment логично вроде как менять reportedTimeMinutes но есть кейсы когда надо меня и _endMoment
                    timeReport._endMoment = moment(timeReport.startMoment).add(timeReport.reportedTimeMinutes, "minutes")
                    timeReport.updatedFields.add('endMoment')
                } else if (timeReport.endMoment) {                                                      // if reportedTimeMinutes is NOT set and endMoment is set then update reportedTimeMinutes
                    timeReport._reportedTimeMinutes = timeReport.endMoment.diff(timeReport.startMoment, "minutes")
                    timeReport.updatedFields.add('reportedTimeMinutes')
                }
            }
            break

        case "endMoment":
            if (!timeReport.endMoment) {                                                                // if endMoment is set to null then startMoment should be set to null too
                timeReport._startMoment = null
                timeReport.updatedFields.add('startMoment')
            } else {                                                                                    // endMoment is set
                if (timeReport.startMoment) {                                                           // if startMoment is set then update reportedTimeMinutes
                    timeReport._reportedTimeMinutes = moment(timeReport.endMoment).diff(timeReport.startMoment, "minutes")
                    // if endMoment is before startMoment then reportedTimeMinutes should be full day minus difference
                    if (timeReport._reportedTimeMinutes < 0) timeReport._reportedTimeMinutes += DAY_IN_MINUTES
                    timeReport.updatedFields.add('reportedTimeMinutes')
                } else if (timeReport.reportedTimeMinutes) {                                            // if startMoment is NOT set and reportedTimeMinutes is set then update startMoment
                    timeReport._startMoment = moment(timeReport.endMoment).subtract(timeReport.reportedTimeMinutes, "minutes")
                    timeReport.updatedFields.add('startMoment')
                }
            }
            break

        case "reportedTimeMinutes":
            if (!timeReport.reportedTimeMinutes) {
                timeReport._startMoment = null
                timeReport.updatedFields.add('startMoment')
                timeReport._endMoment = null
                timeReport.updatedFields.add('endMoment')
            } else if (timeReport.startMoment) {                                                               // if startMoment is set then update endMoment
                timeReport._endMoment = moment(timeReport.startMoment).add(timeReport.reportedTimeMinutes, "minutes")
                timeReport.updatedFields.add('endMoment')
            } else if (timeReport.endMoment) {                                                          // if endMoment is set then update startMoment
                timeReport._startMoment = moment(timeReport.endMoment).subtract(timeReport.reportedTimeMinutes, "minutes")
                timeReport.updatedFields.add('startMoment')
            }
            break
    }
}
